export const isValidPhoneNumber = (phoneNumber, allowNull = false) => (
    (allowNull && phoneNumber === null) ||
    /^(\+\d{1,4})?\d{10}$/.test(phoneNumber)
)

export const extractPhoneNumber = (phoneNumber = '') =>
    phoneNumber.match(/.*(\d{3}).*(\d{3}).*(\d{4})/)?.slice(1).join('') || '';